/**
 * 프로모션 모달 간 세션 레벨 상태 공유
 *
 * 한 번의 페이지 진입(세션)에서 프로모션 모달은 최대 1개만 노출.
 * 모듈 레벨 변수로 SPA 라우팅 중 유지되고, 풀 리로드 시 초기화됨.
 */
let promotionModalShownInSession = false;

export const markPromotionModalShown = () => {
  promotionModalShownInSession = true;
};

export const wasPromotionModalShown = () => promotionModalShownInSession;
